import React from "react";
import DialogButtons from "./DialogButtons";
import { Stack, Typography } from "@mui/material";

type Props = {
  handleModalClose: () => void;
};

function ConfirmDialog({ handleModalClose }: Props) {
  return (
    <Stack width="300px" gap={3}>
      <Typography variant="subtitle2">Do you want to delete this?</Typography>
      <DialogButtons handleModalClose={handleModalClose} />
    </Stack>
  );
}

export default ConfirmDialog;
